import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateCustomer as updateCustomerService } from "../services/customerUpdateService";
import { fetchCustomers } from "../../../../../redux/customers/customerSlice";
import { validateCustomerForm } from "../utils/customerModalUtils";
import { selectedSelectedCustomer } from "../../../../../redux/customers/selectedCustomerSlice";

const useCustomerUpdate = (updateList, extraFetchParams = {}) => {
  const dispatch = useDispatch();
  const selectedCustomer = useSelector(selectedSelectedCustomer);
  const [formData, setFormData] = useState(selectedCustomer ?? {});
  const [validationErrors, setValidationErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Update formData when selectedCustomer changes, but only if a customer is actually selected.
  useEffect(() => {
    if (selectedCustomer) {
      setFormData(selectedCustomer ?? {});
    }
  }, [selectedCustomer]);

  const handleUpdateCustomer = async (autoSave = false) => {
    setIsSubmitting(true);
    const errors = validateCustomerForm(formData);
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      setIsSubmitting(false);
      return false;
    }
    try {
      const success = await updateCustomerService(
        formData.customerID,
        formData
      );
      if (success) {
        updateList();
      }
      return success;
    } catch (error) {
      console.error("Error updating customer:", error);
      setValidationErrors({ form: error.message });
      return false;
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    formData,
    setFormData,
    validationErrors,
    isSubmitting,
    handleUpdateCustomer,
    setValidationErrors,
  };
};

export default useCustomerUpdate;
